// @flow
import type { AgreementsActionType } from './actions';
import type { AgreementSpecification } from 'digicel-kaizen-library';

type AgreementsStateType = {|
  agreementSpecifications: AgreementSpecification[],
|};

const initialState: AgreementsStateType = {
  agreementSpecifications: [],
};

const agreementsReducer = (state: AgreementsStateType = initialState, action: AgreementsActionType) => {
  let agreementSpecifications;

  switch (action.type) {
    case 'SET_AGREEMENT_SPECIFICATIONS':
      agreementSpecifications = action.payload.agreementSpecifications;
      let SelectableAgreementSpecifications: AgreementSpecification[] = [];

      agreementSpecifications.forEach(agreementSpecification =>
        SelectableAgreementSpecifications.push({ ...agreementSpecification, isSelected: false })
      );

      return {
        ...state,
        agreementSpecifications: SelectableAgreementSpecifications,
      };
    case 'TOGGLE_SELECTED_AGREEMENT':
      const { agreementOuid } = action.payload;
      agreementSpecifications = state.agreementSpecifications;

      const agreementSpecification = agreementSpecifications.find(
        agreementSpec => agreementSpec.ouid === agreementOuid
      );

      if (agreementSpecification) {
        agreementSpecification.isSelected = !agreementSpecification.isSelected;
      }

      return state;
    case 'CLEAR_AGREEMENTS':
      return initialState;

    default:
      return state;
  }
};

export default agreementsReducer;
